import React, {CSSProperties} from 'react';
import RoundButton, {RoundButtonProps} from "./RoundButton";
import {alpha, useTheme} from "@mui/material/styles";
import {SvgIcon} from "@mui/material";
import {MuiColorType} from "../lib/interfaces";

const styles = {
    normal: {
        fontSize: "30px !important",
        transition:
                "transform 0.2s ease-in-out,  opacity 0.2s ease-in-out,  color 0.2s ease-in-out",
    },
    enabled: {
        transform: "scale(1.05)",
    }
};

type ControlButtonProps = {
    route?: string;
    badgeContent?: React.ReactNode;
    badgeColor?: 'default' | 'error' | 'primary' | 'secondary' | 'success' | 'info' | 'warning';
    icon: typeof SvgIcon;
    label?: string;
    to?: string;
    labelPlacement?: 'left' | 'right' | 'bottom' | 'top';
    labelEnterDelay?: number;
    enabled?: boolean;
    style?: CSSProperties;
    className?: string;
    width?: number;
    sx?: any; // specify a detailed type if it is known
    color?: MuiColorType;
} & RoundButtonProps;

const ControlButton = (
        {
            className,
            enabled,
            style = {},
            route,
            color,
            ...rest
        }: ControlButtonProps) => {

    const theme = useTheme();

    if (color) {
        style['color'] = color + "  !important";
    } else if (theme) {
        style['color'] = (theme.palette.mode === "dark" ? theme.palette.primary.light : theme.palette.primary.dark) + " !important";
    }

    if (enabled && theme) {
        style['background'] = alpha(color ? color : theme.palette.primary.main, theme.palette.mode === "dark" ? 0.2 : 0.1) + " !important";
    }

    return <RoundButton
            sx={{
                ...styles.normal,
                ...enabled && styles.enabled
            }}
            {...rest}
            style={style}
    >
    </RoundButton>
};

export default ControlButton;
